import client from '@/lib/axios-client'
import type {
	CreateJobGroupBody,
	JobGroup,
	JobGroupListOutput,
	UpdateJobGroupBody,
} from '@/types'

const JOB_GROUPS_URL = '/job-groups'

export async function getJobGroups(): Promise<JobGroupListOutput> {
	const response = await client.get(JOB_GROUPS_URL)
	return response.data.data
}

export async function createJobGroup(
	body: CreateJobGroupBody,
): Promise<JobGroup> {
	const response = await client.post(JOB_GROUPS_URL, body)
	return response.data.data
}

export async function updateJobGroup(
	id: string,
	body: UpdateJobGroupBody,
): Promise<JobGroup> {
	const response = await client.patch(`${JOB_GROUPS_URL}/${id}`, body)
	return response.data.data
}

export async function deleteJobGroup(id: string): Promise<void> {
	await client.delete(`${JOB_GROUPS_URL}/${id}`)
}
